import { getFeedbackResponseSchema, } from '@consigli/types';
import { createParams, createTransformer, mapToSnakeCase, } from './shared/base-api';
export const feedbackApiEndpoints = (builder, coreApiBaseUrl) => ({
    getFeedback: builder.query({
        query: ({ page, pageSize, type, service, createdAtFrom, createdAtTo }) => {
            const params = createParams({
                page,
                pageSize,
                type,
                service,
                createdAtFrom,
                createdAtTo,
            });
            return {
                url: `${coreApiBaseUrl}/feedback/`,
                method: 'GET',
                params: mapToSnakeCase(params),
            };
        },
        providesTags: ['Feedback'],
        transformResponse: createTransformer(getFeedbackResponseSchema, 'getFeedback'),
    }),
});
